"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractImage = require("abstract-image");
var Axis = require("./axis");
var ts_exhaustive_check_1 = require("ts-exhaustive-check");
function createChart(props) {
    var _a = props || {}, _b = _a.width, width = _b === void 0 ? 600 : _b, _c = _a.height, height = _c === void 0 ? 400 : _c, _d = _a.chartPoints, chartPoints = _d === void 0 ? [] : _d, _e = _a.chartLines, chartLines = _e === void 0 ? [] : _e, _f = _a.chartStack, chartStack = _f === void 0 ? createChartStack({}) : _f, _g = _a.xAxisBottom, xAxisBottom = _g === void 0 ? Axis.createLinearAxis(0, 100, "") : _g, _h = _a.xAxisTop, xAxisTop = _h === void 0 ? undefined : _h, _j = _a.yAxisLeft, yAxisLeft = _j === void 0 ? Axis.createLinearAxis(0, 100, "") : _j, _k = _a.yAxisRight, yAxisRight = _k === void 0 ? undefined : _k, _l = _a.backgroundColor, backgroundColor = _l === void 0 ? AbstractImage.white : _l, _m = _a.gridColor, gridColor = _m === void 0 ? AbstractImage.gray : _m, _o = _a.gridThickness, gridThickness = _o === void 0 ? 1 : _o, _p = _a.fontSize, fontSize = _p === void 0 ? 12 : _p, _q = _a.labelLayout, labelLayout = _q === void 0 ? "original" : _q;
    return {
        width: width,
        height: height,
        chartPoints: chartPoints,
        chartLines: chartLines,
        chartStack: chartStack,
        xAxisBottom: xAxisBottom,
        xAxisTop: xAxisTop,
        yAxisLeft: yAxisLeft,
        yAxisRight: yAxisRight,
        backgroundColor: backgroundColor,
        gridColor: gridColor,
        gridThickness: gridThickness,
        fontSize: fontSize,
        labelLayout: labelLayout
    };
}
exports.createChart = createChart;
function createChartPoint(props) {
    var _a = props || {}, _b = _a.shape, shape = _b === void 0 ? "circle" : _b, _c = _a.position, position = _c === void 0 ? AbstractImage.createPoint(0, 0) : _c, _d = _a.color, color = _d === void 0 ? AbstractImage.black : _d, _e = _a.size, size = _e === void 0 ? AbstractImage.createSize(6, 6) : _e, _f = _a.label, label = _f === void 0 ? "" : _f, _g = _a.xAxis, xAxis = _g === void 0 ? "bottom" : _g, _h = _a.yAxis, yAxis = _h === void 0 ? "left" : _h;
    return {
        shape: shape,
        position: position,
        color: color,
        size: size,
        label: label,
        xAxis: xAxis,
        yAxis: yAxis
    };
}
exports.createChartPoint = createChartPoint;
function createChartLine(props) {
    var _a = props || {}, _b = _a.points, points = _b === void 0 ? [] : _b, _c = _a.color, color = _c === void 0 ? AbstractImage.black : _c, _d = _a.thickness, thickness = _d === void 0 ? 1 : _d, _e = _a.label, label = _e === void 0 ? "" : _e, _f = _a.xAxis, xAxis = _f === void 0 ? "bottom" : _f, _g = _a.yAxis, yAxis = _g === void 0 ? "left" : _g;
    return {
        points: points,
        color: color,
        thickness: thickness,
        label: label,
        xAxis: xAxis,
        yAxis: yAxis
    };
}
exports.createChartLine = createChartLine;
function createChartStackConfig(props) {
    var _a = props || {}, _b = _a.color, color = _b === void 0 ? AbstractImage.black : _b, _c = _a.label, label = _c === void 0 ? "" : _c;
    return {
        color: color,
        label: label
    };
}
exports.createChartStackConfig = createChartStackConfig;
function createChartStack(props) {
    var _a = props || {}, _b = _a.points, points = _b === void 0 ? [] : _b, _c = _a.xAxis, xAxis = _c === void 0 ? "bottom" : _c, _d = _a.yAxis, yAxis = _d === void 0 ? "left" : _d, _e = _a.config, config = _e === void 0 ? [createChartStackConfig({})] : _e;
    return {
        points: points,
        xAxis: xAxis,
        yAxis: yAxis,
        config: config
    };
}
exports.createChartStack = createChartStack;
var padding = 80;
function inverseTransformPoint(point, chart, xAxis, yAxis) {
    var xMin = padding;
    var xMax = chart.width - padding;
    var yMin = chart.height - 0.5 * padding;
    var yMax = 0.5 * padding;
    var x = Axis.inverseTransformValue(point.x, xMin, xMax, xAxis === "top" ? chart.xAxisTop : chart.xAxisBottom);
    var y = Axis.inverseTransformValue(point.y, yMin, yMax, yAxis === "right" ? chart.yAxisRight : chart.yAxisLeft);
    if (x === undefined || y === undefined) {
        return undefined;
    }
    return AbstractImage.createPoint(x, y);
}
exports.inverseTransformPoint = inverseTransformPoint;
function renderChart(chart) {
    var width = chart.width, height = chart.height, xAxisBottom = chart.xAxisBottom, xAxisTop = chart.xAxisTop, yAxisLeft = chart.yAxisLeft, yAxisRight = chart.yAxisRight;
    var gridWidth = width - 2 * padding;
    var gridHeight = height - padding;
    var xMin = padding;
    var xMax = width - padding;
    var yMin = height - 0.5 * padding;
    var yMax = 0.5 * padding;
    var renderedBackground = generateBackground(xMin, xMax, yMin, yMax, chart);
    var xNumTicks = gridWidth / 40;
    var renderedXAxisBottom = generateXAxisBottom(xNumTicks, xAxisBottom, xMin, xMax, yMin, yMax, chart);
    var renderedXAxisTop = generateXAxisTop(xNumTicks, xAxisTop, xMin, xMax, yMax, chart);
    var yNumTicks = gridHeight / 40;
    var renderedYAxisLeft = generateYAxisLeft(yNumTicks, yAxisLeft, xMin, xMax, yMin, yMax, chart);
    var renderedYAxisRight = generateYAxisRight(yNumTicks, yAxisRight, xMax, yMin, yMax, chart);
    var renderedPoints = generatePoints(xMin, xMax, yMin, yMax, chart);
    var renderedLines = generateLines(xMin, xMax, yMin, yMax, chart);
    var renderedStack = generateStack(xMin, xMax, yMin, yMax, chart);
    var components = [
        renderedBackground,
        renderedXAxisBottom,
        renderedXAxisTop,
        renderedYAxisLeft,
        renderedYAxisRight,
        renderedStack,
        renderedLines,
        renderedPoints
    ];
    var topLeft = AbstractImage.createPoint(0, 0);
    var size = AbstractImage.createSize(width, height);
    return AbstractImage.createAbstractImage(topLeft, size, AbstractImage.white, components);
}
exports.renderChart = renderChart;
function generateBackground(xMin, xMax, yMin, yMax, chart) {
    var topLeft = AbstractImage.createPoint(xMin, yMax);
    var bottomRight = AbstractImage.createPoint(xMax, yMin);
    return AbstractImage.createRectangle(topLeft, bottomRight, chart.gridColor, chart.gridThickness, chart.backgroundColor);
}
exports.generateBackground = generateBackground;
function generateXAxisBottom(xNumTicks, xAxisBottom, xMin, xMax, yMin, yMax, chart) {
    if (!xAxisBottom) {
        return AbstractImage.createGroup("XAxisBottom", []);
    }
    var xTicks = Axis.getTicks(xNumTicks, xAxisBottom);
    var xLines = generateXAxisGridLines(xMin, xMax, yMin + 10, yMax, xTicks, xAxisBottom, chart);
    var xLabels = generateXAxisLabels(xMin, xMax, yMin + 10, "down", xTicks, xAxisBottom, chart);
    var xLabel;
    switch (chart.labelLayout) {
        case "original":
            xLabel = generateXAxisLabel(xMax + 0.5 * padding, yMin + 10, "uniform", "down", xAxisBottom.label, chart);
            break;
        case "end":
            xLabel = generateXAxisLabel(xMax, yMin + 25, "left", "down", xAxisBottom.label, chart);
            break;
        case "center":
            xLabel = generateXAxisLabel((xMin + xMax) / 2, yMin + 25, "uniform", "down", xAxisBottom.label, chart);
            break;
        default:
            return ts_exhaustive_check_1.exhaustiveCheck(chart.labelLayout);
    }
    return AbstractImage.createGroup("XAxisBottom", [xLines, xLabels, xLabel]);
}
exports.generateXAxisBottom = generateXAxisBottom;
function generateXAxisTop(xNumTicks, xAxisTop, xMin, xMax, yMax, chart) {
    if (!xAxisTop) {
        return AbstractImage.createGroup("XAxisTop", []);
    }
    var xTicks2 = Axis.getTicks(xNumTicks, xAxisTop);
    var xLines2 = generateXAxisGridLines(xMin, xMax, yMax - 10, yMax, xTicks2, xAxisTop, chart);
    var xLabels2 = generateXAxisLabels(xMin, xMax, yMax - 13, "up", xTicks2, xAxisTop, chart);
    var xLabel2;
    switch (chart.labelLayout) {
        case "original":
            xLabel2 = generateXAxisLabel(xMax + 0.5 * padding, yMax - 13, "uniform", "up", xAxisTop.label, chart);
            break;
        case "end":
            xLabel2 = generateXAxisLabel(xMax, yMax - 30, "left", "up", xAxisTop.label, chart);
            break;
        case "center":
            xLabel2 = generateXAxisLabel((xMin + xMax) / 2, yMax - 30, "uniform", "up", xAxisTop.label, chart);
            break;
        default:
            return ts_exhaustive_check_1.exhaustiveCheck(chart.labelLayout);
    }
    return AbstractImage.createGroup("XAxisTop", [xLines2, xLabels2, xLabel2]);
}
exports.generateXAxisTop = generateXAxisTop;
function generateYAxisLeft(yNumTicks, yAxisLeft, xMin, xMax, yMin, yMax, chart) {
    if (!yAxisLeft) {
        return AbstractImage.createGroup("YAxisLeft", []);
    }
    var yTicks = Axis.getTicks(yNumTicks, yAxisLeft);
    var yLines = generateYAxisLines(xMin - 5, xMax, yMin, yMax, yTicks, yAxisLeft, chart);
    var yLabels = generateYAxisLabels(xMin - 7, yMin, yMax, "left", yTicks, yAxisLeft, chart);
    var labelPaddingLeft = 5 + labelPadding(formatNumber(yAxisLeft.max).length, chart.fontSize, 0.5);
    var yLabel;
    switch (chart.labelLayout) {
        case "original":
            yLabel = generateYAxisLabel(xMin - labelPaddingLeft, yMax + 0.5 * padding, "uniform", "up", yAxisLeft.label, chart);
            break;
        case "end":
            yLabel = generateYAxisLabel(xMin - labelPaddingLeft, yMax, "left", "up", yAxisLeft.label, chart);
            break;
        case "center":
            yLabel = generateYAxisLabel(xMin - labelPaddingLeft, (yMin + yMax) / 2, "uniform", "up", yAxisLeft.label, chart);
            break;
        default:
            return ts_exhaustive_check_1.exhaustiveCheck(chart.labelLayout);
    }
    return AbstractImage.createGroup("YAxisLeft", [yLines, yLabels, yLabel]);
}
exports.generateYAxisLeft = generateYAxisLeft;
function generateYAxisRight(yNumTicks, yAxisRight, xMax, yMin, yMax, chart) {
    if (!yAxisRight) {
        return AbstractImage.createGroup("YAxisRight", []);
    }
    var yTicks2 = Axis.getTicks(yNumTicks, yAxisRight);
    var yLines2 = generateYAxisLines(xMax - 5, xMax + 5, yMin, yMax, yTicks2, yAxisRight, chart);
    var yLabels2 = generateYAxisLabels(xMax + 7, yMin, yMax, "right", yTicks2, yAxisRight, chart);
    var labelPaddingRight = 7 + labelPadding(formatNumber(yAxisRight.max).length, chart.fontSize, 1.5);
    var yLabel2;
    switch (chart.labelLayout) {
        case "original":
            yLabel2 = generateYAxisLabel(xMax + labelPaddingRight, yMax + 0.5 * padding, "uniform", "up", yAxisRight.label, chart);
            break;
        case "end":
            yLabel2 = generateYAxisLabel(xMax + labelPaddingRight, yMax, "left", "up", yAxisRight.label, chart);
            break;
        case "center":
            yLabel2 = generateYAxisLabel(xMax + labelPaddingRight, (yMin + yMax) / 2, "uniform", "up", yAxisRight.label, chart);
            break;
        default:
            return ts_exhaustive_check_1.exhaustiveCheck(chart.labelLayout);
    }
    return AbstractImage.createGroup("YAxisRight", [yLines2, yLabels2, yLabel2]);
}
exports.generateYAxisRight = generateYAxisRight;
function generateStack(xMin, xMax, yMin, yMax, chart) {
    var pointsPos = chart.chartStack.points.map(function (stackPoint) { return ({
        x: stackPoint.x,
        ys: stackPoint.ys.map(function (y) { return Math.min(0, y); }).slice()
    }); });
    var stackPos = generateUnsignedStack(xMin, xMax, yMin, yMax, __assign({}, chart, { chartStack: __assign({}, chart.chartStack, { points: pointsPos }) }));
    var pointsNeg = chart.chartStack.points.map(function (stackPoint) { return ({
        x: stackPoint.x,
        ys: stackPoint.ys.map(function (y) { return Math.max(0, y); }).slice()
    }); });
    var stackNeg = generateUnsignedStack(xMin, xMax, yMin, yMax, __assign({}, chart, { chartStack: __assign({}, chart.chartStack, { points: pointsNeg }) }));
    return AbstractImage.createGroup("Stacks", [stackPos, stackNeg]);
}
exports.generateStack = generateStack;
function generateUnsignedStack(xMin, xMax, yMin, yMax, chart) {
    if (chart.chartStack.points.length < 2) {
        return AbstractImage.createGroup("stack", []);
    }
    var xAxis = chart.chartStack.xAxis === "top" ? chart.xAxisTop : chart.xAxisBottom;
    var yAxis = chart.chartStack.yAxis === "right" ? chart.yAxisRight : chart.yAxisLeft;
    var xPoints = chart.chartStack.points.map(function (stackPoints) {
        var sumY = 0;
        var points = stackPoints.ys.map(function (y) {
            sumY += y;
            return Axis.transformPoint(AbstractImage.createPoint(stackPoints.x, sumY), xMin, xMax, yMin, yMax, xAxis, yAxis);
        });
        return points;
    });
    // Transpose the xPoints data to lines.
    var lines = [];
    for (var i = 0; i < xPoints[0].length; ++i) {
        lines[i] = [];
        for (var _i = 0, xPoints_1 = xPoints; _i < xPoints_1.length; _i++) {
            var points = xPoints_1[_i];
            lines[i].push(points[i]);
        }
    }
    var polygons = [];
    var lastLine = chart.chartStack.points.map(function (stackPoint) {
        return Axis.transformPoint(AbstractImage.createPoint(stackPoint.x, 0), xMin, xMax, yMin, yMax, xAxis, yAxis);
    });
    lines.forEach(function (line, index) {
        var config = chart.chartStack.config[index];
        if (!config) {
            throw new Error("Missing config for series " + index);
        }
        var color = config.color;
        var points = line.concat(lastLine.slice().reverse());
        lastLine = line;
        polygons.push(AbstractImage.createPolygon(points, color, 0, color));
    });
    return AbstractImage.createGroup("Stack", polygons);
}
function generateLines(xMin, xMax, yMin, yMax, chart) {
    var lines = chart.chartLines.map(function (l) {
        if (l.points.length < 2) {
            return AbstractImage.createGroup(l.label, []);
        }
        var xAxis = l.xAxis === "top" ? chart.xAxisTop : chart.xAxisBottom;
        var yAxis = l.yAxis === "right" ? chart.yAxisRight : chart.yAxisLeft;
        var points = l.points.map(function (p) {
            return Axis.transformPoint(p, xMin, xMax, yMin, yMax, xAxis, yAxis);
        });
        var last = points[points.length - 1];
        return AbstractImage.createGroup(l.label, [
            AbstractImage.createPolyLine(points, l.color, l.thickness),
            AbstractImage.createText(last, l.label, "Arial", chart.fontSize, AbstractImage.black, "normal", 0, "center", "right", "down", 0, AbstractImage.black)
        ]);
    });
    return AbstractImage.createGroup("Lines", lines);
}
exports.generateLines = generateLines;
function generatePoints(xMin, xMax, yMin, yMax, chart) {
    var points = chart.chartPoints.map(function (p) {
        var xAxis = p.xAxis === "top" ? chart.xAxisTop : chart.xAxisBottom;
        var yAxis = p.yAxis === "right" ? chart.yAxisRight : chart.yAxisLeft;
        var position = Axis.transformPoint(p.position, xMin, xMax, yMin, yMax, xAxis, yAxis);
        var shape = generatePointShape(p, position);
        return AbstractImage.createGroup(p.label, [
            shape,
            AbstractImage.createText(position, p.label, "Arial", chart.fontSize, AbstractImage.black, "normal", 0, "center", "right", "down", 0, AbstractImage.black)
        ]);
    });
    return AbstractImage.createGroup("Points", points);
}
exports.generatePoints = generatePoints;
function generatePointShape(p, position) {
    var halfWidth = p.size.width * 0.5;
    var halfHeight = p.size.height * 0.5;
    if (p.shape === "triangle") {
        var trianglePoints = [
            AbstractImage.createPoint(position.x, position.y + halfHeight),
            AbstractImage.createPoint(position.x - halfWidth, position.y - halfHeight),
            AbstractImage.createPoint(position.x + halfWidth, position.y - halfHeight)
        ];
        return AbstractImage.createPolygon(trianglePoints, AbstractImage.black, 1, p.color);
    }
    else if (p.shape === "square") {
        var topLeft = AbstractImage.createPoint(position.x - halfWidth, position.y - halfHeight);
        var bottomRight = AbstractImage.createPoint(position.x + halfWidth, position.y + halfHeight);
        return AbstractImage.createRectangle(topLeft, bottomRight, AbstractImage.black, 1, p.color);
    }
    else {
        var topLeft = AbstractImage.createPoint(position.x - halfWidth, position.y - halfHeight);
        var bottomRight = AbstractImage.createPoint(position.x + halfWidth, position.y + halfHeight);
        return AbstractImage.createEllipse(topLeft, bottomRight, AbstractImage.black, 1, p.color);
    }
}
function generateXAxisGridLines(xMin, xMax, yMin, yMax, xTicks, xAxis, chart) {
    var xLines = xTicks.map(function (l) {
        var x = Axis.transformValue(l, xMin, xMax, xAxis);
        var start = AbstractImage.createPoint(x, yMin);
        var end = AbstractImage.createPoint(x, yMax);
        return AbstractImage.createLine(start, end, chart.gridColor, chart.gridThickness);
    });
    return AbstractImage.createGroup("Lines", xLines);
}
exports.generateXAxisGridLines = generateXAxisGridLines;
function generateXAxisLabels(xMin, xMax, y, growVertical, xTicks, xAxis, chart) {
    var xLabels = xTicks.map(function (l) {
        var position = AbstractImage.createPoint(Axis.transformValue(l, xMin, xMax, xAxis), y);
        return AbstractImage.createText(position, formatNumber(l), "Arial", chart.fontSize, AbstractImage.black, "normal", 0, "center", "uniform", growVertical, 0, AbstractImage.black);
    });
    return AbstractImage.createGroup("Labels", xLabels);
}
exports.generateXAxisLabels = generateXAxisLabels;
function generateXAxisLabel(x, y, horizontalGrowthDirection, verticalGrowthDirection, label, chart) {
    var position = AbstractImage.createPoint(x, y);
    return AbstractImage.createText(position, label, "Arial", chart.fontSize, AbstractImage.black, "normal", 0, "center", horizontalGrowthDirection, verticalGrowthDirection, 0, AbstractImage.black);
}
exports.generateXAxisLabel = generateXAxisLabel;
function generateYAxisLines(xMin, xMax, yMin, yMax, yTicks, yAxis, chart) {
    var yLines = yTicks.map(function (l) {
        var y = Axis.transformValue(l, yMin, yMax, yAxis);
        var start = AbstractImage.createPoint(xMin, y);
        var end = AbstractImage.createPoint(xMax, y);
        return AbstractImage.createLine(start, end, chart.gridColor, chart.gridThickness);
    });
    return AbstractImage.createGroup("Lines", yLines);
}
exports.generateYAxisLines = generateYAxisLines;
function generateYAxisLabels(x, yMin, yMax, growHorizontal, yTicks, yAxis, chart) {
    var yLabels = yTicks.map(function (l) {
        var position = AbstractImage.createPoint(x, Axis.transformValue(l, yMin, yMax, yAxis));
        return AbstractImage.createText(position, formatNumber(l), "Arial", chart.fontSize, AbstractImage.black, "normal", 0, "center", growHorizontal, "uniform", 0, AbstractImage.black);
    });
    return AbstractImage.createGroup("Labels", yLabels);
}
exports.generateYAxisLabels = generateYAxisLabels;
function generateYAxisLabel(x, y, horizontalGrowthDirection, verticalGrowthDirection, label, chart) {
    var position = AbstractImage.createPoint(x, y);
    return AbstractImage.createText(position, label, "Arial", chart.fontSize, AbstractImage.black, "normal", -90, "center", horizontalGrowthDirection, verticalGrowthDirection, 0, AbstractImage.black);
}
exports.generateYAxisLabel = generateYAxisLabel;
function formatNumber(n) {
    if (n >= 10000000) {
        return numberToString(n / 1000000) + "m";
    }
    if (n >= 10000) {
        return numberToString(n / 1000) + "k";
    }
    return numberToString(n);
}
function numberToString(n) {
    return parseFloat(n.toPrecision(5)).toString();
}
function labelPadding(numberOfCharacters, fontSize, characterOffset) {
    return (numberOfCharacters + 1 + characterOffset) * fontSize * 3 / 4;
}
//# sourceMappingURL=chart.js.map